import { apiClient } from "@/state/modules/apiClient";
const controller = "SiteInfo";

export const state = {};

export const mutations = {};
export const actions = {
  async getSiteInfo({ commit }) {
    return apiClient.get(controller + "/get-public");
  },

  async create({ commit }, values) {
    return apiClient.post(controller + "/create", values);
  },
  async update({ commit, dispatch }, values) {
    return apiClient.post(controller + "/update", values);
  },
  async delete({ commit }, id) {
    return await apiClient.post(controller + "/delete", id);
  },
  async getById({ commit }, id) {
    return apiClient.post(controller + "/get-by-id-core", id);
  },
  async getByCode({ commit }, code) {
    return apiClient.get(controller + "/get-by-code/" + code);
  },
};
